const React = require('react');
const T = require('prop-types');
const { default: Styled } = require('styled-components');

const { default: MuiSwitch } = require('@mui/material/Switch');
const { default: Button } = require('@mui/material/Button');
const { default: Dialog } = require('@mui/material/Dialog');
const { default: DialogActions } = require('@mui/material/DialogActions');
const { default: DialogContent } = require('@mui/material/DialogContent');
const { default: DialogContentText } = require('@mui/material/DialogContentText');
const { default: DialogTitle } = require('@mui/material/DialogTitle');

const FocusIndicator = require('components/FocusIndicator');

const internals = {};

module.exports = function SimpleDialog(props) {

    const { Actions } = internals;
    const {
        isOpen,
        onRequestClose,
        onConfirm,
        title,
        content: Content,
        buttons: Buttons,
        ...rest
    } = props;

    const onClose = () => {

        FocusIndicator.onBlurHandler();
        onRequestClose?.();
    };

    const _onConfirm = () => {

        if (onConfirm) {
            FocusIndicator.onBlurHandler();
            onConfirm();
        }
        else {
            onClose();
        }
    };

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            aria-labelledby='alert-logout-dialog-title'
            aria-describedby='alert-logout-dialog-description'
            {...rest}
        >
            <div tabIndex={0} data-focus-outline='radius:15'>
                <DialogTitle id='alert-logout-dialog-title'>{title}</DialogTitle>
                <DialogContent sx={{ minWidth: 300 }}>
                    {React.isValidElement(Content) && Content}
                    {!React.isValidElement(Content) && <DialogContentText id='alert-logout-dialog-description'>
                        {Content}
                    </DialogContentText>}
                </DialogContent>
                <DialogActions>
                    <Actions>
                        {Buttons || (
                            <Button
                                onClick={_onConfirm}
                                color='primary'
                                variant='contained'
                                data-focus-outline='radius:40'
                            >
                                Ok
                            </Button>
                        )}
                    </Actions>
                </DialogActions>
            </div>
        </Dialog>
    );
};

module.exports.propTypes = {
    isOpen: T.bool,
    onRequestClose: T.func,
    onConfirm: T.func,
    title: T.string,
    content: T.any,
    buttons: T.any
};

internals.Actions = Styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 8px;
`;

internals.StyledSwitch = Styled(MuiSwitch)`
    .MuiSwitch-input {
        left: 0;
        width: 100%;
    }
`;
